module.exports = __webpack_public_path__ + "img/location-world.7061df68.jpg";